<template>
    <div class="container">
        <div class="flex-1 mt-9">
            <!-- search options-->
            <div class="w-full max-w-7xl mt-5">
                <div class="flex justify-between items-center gap-5 flex-wrap">
                    <div class="flex justify-between items-center gap-5">
                        <DesignDropdownSelect
                            v-model="selectDate.departmentSeq"
                            :options="departmentOptions"
                            size="LG"
                            :width="'w-[186px]'"
                            placeholder="All Departments"
                            :useDefaultMsg="true"
                            @change="fetchPointBalance(0)" />
                        <DesignDropdownSelect
                            v-model="selectDate.jobTitleSeq"
                            :options="jobTitleOptions"
                            size="LG"
                            :width="'w-[186px]'"
                            placeholder="All Tiers"
                            :useDefaultMsg="true"
                            @change="fetchPointBalance(0)" />
                        <DesignDropdownSelect
                            v-model="selectDate.employmentType"
                            :options="employmentTypeOptions"
                            size="LG"
                            :width="'w-[186px]'"
                            :placeholder="'All Contract Type'"
                            :useDefaultMsg="true"
                            :height12="true"
                            @change="fetchPointBalance(0)" />
                        <ElementsSearchBar
                            v-model="employeeNameForSearch"
                            :options="employeeOptions"
                            :height12="true"
                            widthCustom="w-[200px]"
                            :placeholder="employeePlaceholder"
                            @searchEvent="fetchPointBalance(0)"
                            ref="employeeSearchBar"
                            :optionClickEvent="true"
                            :hasSearchButton="true" />
                    </div>

                    <DesignButton 
                        btnText="Download Excel" btnSize="LG" btnType="QUATERNARY" :btnDisabled="false"
                        @click-event="clickExcelDownload" 
                    />

                    <!--for aboitiz - cost center-->
                    <div v-show="isAboitiz" class="flex w-full border-t border-gray-300 my-2"></div>
                    <ElementsSelectSearchBar
                        v-show="isAboitiz"
                        v-model="selectSearchBar"
                        @searchEvent="fetchPointBalance(0)"
                        :height12="true"
                        :useDefaultMsg="true"
                        :selectTypeList="selectOptionList"
                        selectWidthCustom="w-[180px]"
                        :selectPlaceholder="selectSearchPlaceholder"
                        :selectDisable="true"
                        :fixedSelectVal="fixedSelectVal"
                        textWidthCustom="w-[200px]"
                        :textPlaceholder="costCenterPlaceholder"
                        ref="employeeSelectSearchBar"
                        :optionClickEvent="true"
                        :hasSearchButton="true" />

                    <ElementsNotification v-model="showExcelDisableNoti" notificationMsg="There are no downloadable history" :warning="true" />
                </div>
            </div>

            <div id="employees" class="mt-3 w-full max-w-7xl">
                <table class="w-full table-fixed border border-gray-300 rounded-lg bg-white font-inter-heading-19">
                    <colgroup>
                        <col style="width: 3rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <template v-if="isAboitiz">
                            <col style="width: 12rem">
                        </template>
                    </colgroup>
                    <thead class="border-b border-gray-300 text-gray-600 rounded-t-lg bg-background-basic-2">
                        <tr>
                            <th scope="col" class="py-4 pl-4 font-inter-heading-19 pr-2 text-center">No</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Name</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Department</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Tier</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Available<br/>Points</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Contract<br/>Type</th>
                            <th scope="col" class="py-4 pl-2 font-inter-heading-19 pr-4 text-center">Latest<br/>Transfer</th>
                            <th v-if="isAboitiz" scope="col" class="py-4 pl-2 pr-4 text-center">Cost<br/>Center</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, index) in pointList" :key="index" :class="{ 'bg-slate-50': index % 2 !== 0 }" class="bg-white">
                            <td class="font-inter-heading-20 py-2.5 pl-4 pr-2 text-sm font-normal text-center">
                                {{ index + 1 + indexNo }}
                            </td>
                            <td class="font-inter-heading-20 px-2 py-2">
                                <div class="flex items-center gap-2">
                                    <StatusCircle :status-code="data.employeeStatus" />
                                    <div class="font-semibold">
                                        <span class="block line-clamp-2 break-words">{{ $validateUtil.emptyValueToDash(data.employeeName) }}</span>
                                    </div>
                                </div>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.emptyValueToDash(data.departmentName) }}
                                </span>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.emptyValueToDash(data.jobTitleName) }}
                                </span>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.numberWithCommas(data.walletEmployeeMileage) }}
                                </span>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.emptyValueToDash(getDisplayTextOfEmploymentType(data.employmentType)) }}
                                </span>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <div v-html="$dateFormatUtil.convertDateTimeToMMddyyyyHHmm(data.latestReceivedTransferDatetime)"/>
                            </td>
                            <td v-if="isAboitiz" class="px-2 text-center font-inter-heading-20 ">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.emptyValueToDash(data.costCenterName) }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="pointList.length === 0">
                            <td :colspan="isAboitiz ? 8 : 7" class="py-16 text-center text-content-basic-3 text-sm">
                                No employees found.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="w-full h-28 flex justify-center items-center">
                        <ElementsPagination
                            v-model="currentPage"
                            :totalContent="pointCount"
                            :contentsPerPage="limit"
                            @clickPage="afterClickPage"
                        />
                    </div>
                
            </div>


        </div>
    </div>
</template>

<script>
import AppAside from '@/components/AppAside.vue';
import AppMain from '@/components/main/AppMain.vue';
import ElementsNotification from '@/components/elements/ElementsNotification.vue';
import ElementsSelectSearchBar from '@/components/elements/ElementsSelectSearchBar';
import DesignButton from '@/components/design-system/design-button.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import ElementsDateSearchPack from '@/components/elements/ElementsDateSearchPack.vue';
import ElementsPopupDownloadExcel from '@/components/elements/ElementsPopupDownloadExcel.vue';
import ElementsSearchBar from '@/components/elements/ElementsSearchBar.vue';
import ElementsPagination from '@/components/elements/ElementsPagination.vue';
import StatusCircle from '@/components/employee/status-circle/status-circle';
import {CommonDataFormatUtil} from "@/plugins/app-util";
import { getAboitizInfo } from '@/plugins/app-pre-init';
import { contractType } from '@/assets/data/optionData.js';

export default {
    components: {
        AppAside,
        AppMain,
        ElementsNotification,
        ElementsSelectSearchBar,
        DesignButton,
        ElementsPagination,
        StatusCircle,
        DesignDropdownSelect,
        ElementsDateSearchPack,
        ElementsPopupDownloadExcel,
        ElementsSearchBar,
    },
    data() {
        return {
            pointList: [],
            pointCount: 0,
            limit: 10,
            offset: 0,
            currentPage: null,
            indexNo: 0,

            subAdminOverviewList: [],
            walletCategoryList: [],
            walletColIndexes: [],
            walletTotals: [],
            grandTotal: 0,

            transactionTypeOptions: [
                { text: 'Type', value: null },
                { text: 'Top up', value: 'TOPUP_FROM_HRFLEX' },
                { text: 'Deduct', value: 'DEDUCT_TO_HRFLEX' },
                { text: 'Transfer', value: 'TRANSFER_TO_EMPLOYEE' },
                { text: 'Withdraw', value: 'DEDUCT_FROM_EMPLOYEE' },
            ],

            // for aboitiz (cost center)
            aboitizSeq: getAboitizInfo().companySeq,
            companySeq: sessionStorage.getItem("companySeq"),
            isAboitiz: false,

            // search controls used in template
            selectDate: {
                limit: 10,
                offset: 0,
                departmentSeq: null,
                jobTitleSeq: null,
                employmentType: null,
                employeeSeqList: null,
                startSearchDate: null,
                endSearchDate: null,
                schType: null,
                schKeyword: null,
            },
            employeeNameForSearch: null,
            employeeOptions: [],
            departmentOptions: [],
            jobTitleOptions: [],
            employmentTypeOptions: contractType,
            employeePlaceholder: 'Search Employees',
            showExcelDisableNoti: false,
            selectSearchBar: '',
            selectSearchPlaceholder: 'Search Type',
            selectOptionList: [
                { value: 'COST_CENTER', text: 'Cost Center' },
                { value: 'BUSINESS_UNIT', text: 'Business Unit' },
            ],
            fixedSelectVal: {
                value: 'COST_CENTER',
                text: 'Cost Center',
            },
            costCenterPlaceholder: 'Search Cost Center',
        };
    },
    mounted() {
        const self = this;
        self.getEmployeeOptions();
        self.getDepartmentOptions();
        self.getJobTitleOptions();
        // refs 바인딩 이후 첫 조회 수행
        self.$nextTick(() => {
            self.fetchPointBalance(0);
        });
    },
    beforeMount() {
        const self = this;
        self.isAboitiz = self.aboitizSeq == self.companySeq;
    },
    methods: {
        formatPoints(v) {
            if (v == null || isNaN(v)) return '-';
            try { return new Intl.NumberFormat().format(v) + 'P'; } catch { return v + 'P'; }
        },
        getDepartmentOptions() {
            // Departments
            const self = this;

            const url = self.$api('uri', 'get-department');
            const json_query = JSON.stringify({
                showRootNode: true,
                menuAccessLevelCode: "FLEXBEN_ACCESS_LEVEL",
            });
            self.$axios.get(url, { params: { json_query } }).then((res) => {
                const options = res.data.data.list.map((dep) => ({
                    text: dep.departmentName,
                    value: dep.departmentSeq,
                }));

                self.departmentOptions.push(...options);
            });
        },
        getJobTitleOptions() {
            // Tiers
            const self = this;

            const json_query = JSON.stringify({
                limit: -1,
                offset: 0,
            });
            const url = self.$api('uri', 'get-jobTitle');
            self.$axios.get(url, { params: { json_query } }).then((res) => {
                const options = res.data.data.list.map((title) => ({ text: title.jobTitleName, value: title.jobTitleSeq }));
                self.jobTitleOptions.push(...options);
            });
        },
        getEmployeeOptions() {
            const self = this;

            // point balance는 resign한 직원까지 모두 검색할 수 있다.
            // 본인에게 할당된 직원 
            let url = self.$api('uri', 'get-employee-all-with-resigned')
            const json_query = JSON.stringify({
                limit: -1,
                offset: 0,
            });

            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                    self.employeeOptions = res.data.data.list.map((emp) => ({ text: emp.employeeName, value: emp.employeeSeq }));
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        getDisplayTextOfEmploymentType : CommonDataFormatUtil.employmentTypeFormat,
        afterClickPage(offset) {
            const self = this;
            self.indexNo = offset;
            self.fetchPointBalance(offset);
        },
        getTransactionName(transactionType) {
            const self = this;
            if( !transactionType ) return '-';

            let transactionName = '';
            transactionName = self.transactionTypeOptions.find((type) => type.value == transactionType).text;

            return transactionName;
        },
        getPointList(list, count, currentPage, indexNo){
            const self = this;
            self.pointList = list;
            self.pointCount = count;
            self.currentPage = currentPage;
            self.indexNo = indexNo;
        },
        clickExcelDownload() {
            const self = this;
            if (!self.pointList || self.pointList.length === 0) {
                self.showExcelDisableNoti = true;
                return;
            }

            let schType = null;
            let schKeyword = null;
            if (self.isAboitiz) {
                const selectRef = self.$refs.employeeSelectSearchBar;
                const vals = selectRef && selectRef.getSearchedValues ? selectRef.getSearchedValues() : null;
                if (vals) {
                    schType = vals.schType;
                    schKeyword = vals.schKeyword;
                }
            }

            const sendData = {
                limit: -1,
                offset: 0,
                departmentSeq: self.selectDate.departmentSeq,
                jobTitleSeq: self.selectDate.jobTitleSeq,
                employmentType: self.selectDate.employmentType,
                employeeSeqList: self.$refs.employeeSearchBar?.getSearchedValues?.() ?? self.selectDate.employeeSeqList ?? null,
                schType,
                schKeyword,
            };
            const json_query = JSON.stringify(sendData);
            const url = self.$api('uri', 'get-point-balance-for-sub-admin-file');
            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                    const downloadLink = res?.data?.data?.excelFilePath;
                    if (downloadLink) {
                        const aElem = document.createElement('a');
                        aElem.href = downloadLink;
                        aElem.click();
                    }
                })
                .catch((err) => {
                    console.error('excel download error:', err);
                });
        },
        fetchPointBalance(offset = 0) {
            const self = this;
            self.selectDate.offset = offset;
            self.selectDate.employeeSeqList = self.$refs.employeeSearchBar?.getSearchedValues?.() ?? null;

            // aboitiz select-search (optional)
            if (self.isAboitiz) {
                const vals = self.$refs.employeeSelectSearchBar?.getSearchedValues?.() || null;
                self.selectDate.schType = vals?.schType || null;
                self.selectDate.schKeyword = vals?.schKeyword || null;
            }

            const url = self.$api('uri', 'get-point-balance-for-sub-admin');
            const json_query = JSON.stringify(self.selectDate);
            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                    const payload = res?.data?.data || {};
                    self.pointList = payload.list || [];
                    self.pointCount = payload.count ?? payload.total ?? 0;
                    self.currentPage = offset ? offset / self.selectDate.limit + 1 : 1;
                })
                .catch((err) => {
                    console.error('fetchPointBalance error:', err);
                    self.pointList = [];
                    self.pointCount = 0;
                });
        },
        fetchSubAdminOverview() {
            const self = this;
            const url = self.$api('uri', 'get-sub-admin-overview');
            return self.$axios
                .get(url, { params: { sortBy: self.sortBy, order: self.order } })
                .then((res) => {
                    self.subAdminOverviewList = res.data?.data?.list ?? [];
                    // After list loads, recompute wallet totals
                    self.computeWalletTotals();
                })
                .catch((err) => {
                    console.error('getSubAdminOverview error', err);
                });
        },
        // Safely extract wallet balance for given row and wallet column index
        getWalletAmount(row, walletIndex) {
            try {
                const cat = this.walletCategoryList?.[walletIndex];
                if (!cat) return 0;
                const catSeq = cat.walletCategorySeq || cat.walletCategoryId || cat.seq;
                // Candidates arrays where balances may live
                const candidateArrays = [
                    row.walletBalances,
                    row.walletCategoryBalances,
                    row.walletCategoryBalanceList,
                    row.walletCategoryList,
                    row.walletMileageList,
                ].filter(Array.isArray);
                for (const arr of candidateArrays) {
                    const found = arr.find((it) => (
                        (it.walletCategorySeq || it.walletCategoryId || it.seq) === catSeq
                    ));
                    if (found) {
                        const val = found.balance ?? found.mileage ?? found.totalMileage ?? found.amount ?? found.walletMileage ?? 0;
                        const num = Number(val);
                        return Number.isFinite(num) ? num : 0;
                    }
                }
                // Fallback if row has object map keyed by category seq
                const mapCandidates = [row.walletBalancesByCategory, row.walletMileageByCategory];
                for (const map of mapCandidates) {
                    if (map && catSeq in map) {
                        const num = Number(map[catSeq]);
                        return Number.isFinite(num) ? num : 0;
                    }
                }
                return 0;
            } catch {
                return 0;
            }
        },
        // Compute per-column totals and grand total for sub-admin view
        computeWalletTotals() {
            const count = this.walletColIndexes?.length || 0;
            this.walletTotals = Array.from({ length: count }, (_, i) => {
                return (this.subAdminOverviewList || []).reduce((sum, row) => sum + this.getWalletAmount(row, i), 0);
            });
            this.grandTotal = this.walletTotals.reduce((a, b) => a + b, 0);
        },
    },
};
</script>
<style scoped>
</style>
